import { g as n } from "../../utils-BOfnFgIH.js";
import { I as e } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as d, normalizeClass as r, createElementVNode as t, createStaticVNode as i } from "vue";
import { _ as p } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconOffice365",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (o) => Object.keys(e).includes(o)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return e[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], f = ["fill"], _ = ["fill"], h = ["fill"], m = ["fill"], y = ["fill"], I = ["id"], g = /* @__PURE__ */ i('<stop stop-color="#FFB900"></stop><stop offset=".166" stop-color="#EF8400"></stop><stop offset=".313" stop-color="#E25C01"></stop><stop offset=".429" stop-color="#DB4401"></stop><stop offset=".5" stop-color="#D83B01"></stop>', 5), q = [
  g
], D = ["id"], S = /* @__PURE__ */ i('<stop stop-color="#800600"></stop><stop offset=".6" stop-color="#C72127"></stop><stop offset=".728" stop-color="#C13959"></stop><stop offset=".847" stop-color="#BC4B81"></stop><stop offset=".942" stop-color="#B95799"></stop><stop offset="1" stop-color="#B85BA2"></stop>', 6), v = [
  S
], B = ["id"], $ = /* @__PURE__ */ t("stop", { "stop-color": "#F32B44" }, null, -1), U = /* @__PURE__ */ t("stop", {
  offset: ".6",
  "stop-color": "#A4070A"
}, null, -1), z = [
  $,
  U
], O = ["id"], b = /* @__PURE__ */ t("stop", { "stop-opacity": ".4" }, null, -1), C = /* @__PURE__ */ t("stop", {
  offset: "1",
  "stop-opacity": "0"
}, null, -1), A = [
  b,
  C
], E = ["id"], L = /* @__PURE__ */ t("stop", { "stop-opacity": ".4" }, null, -1), w = /* @__PURE__ */ t("stop", {
  offset: "1",
  "stop-opacity": "0"
}, null, -1), x = [
  L,
  w
];
function F(o, G, a, V, k, s) {
  return d(), l("svg", {
    "aria-label": a.ariaLabel,
    class: r([s.iconSizeClass, "d-icon d-icon--office-365"]),
    "data-qa": s.dataQA,
    "aria-hidden": s.ariaHidden,
    role: "img",
    "data-name": "Office 365",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    t("path", {
      d: "m12.571 2.069 1.366 3.597v12.297l-1.333 3.97 5.902-1.639a1.904 1.904 0 0 0 1.393-1.834V5.542a1.903 1.903 0 0 0-1.396-1.835L12.571 2.07z",
      fill: `url(#${o.uniqueID}a)`
    }, null, 8, f),
    t("path", {
      d: "m7.239 16.878-1.757.96A1.001 1.001 0 0 1 4 16.96V7.45a1.9 1.9 0 0 1 .954-1.65l6.192-3.553a1.869 1.869 0 0 1 1.642-.107 1.86 1.86 0 0 1 1.15 1.724v1.8L8.904 7.5a1.415 1.415 0 0 0-.93 1.33v6.807a1.415 1.415 0 0 1-.736 1.24z",
      fill: `url(#${o.uniqueID}b)`
    }, null, 8, _),
    t("path", {
      d: "M13.937 17.963v2.214a1.82 1.82 0 0 1-2.713 1.59l-3.88-2.174a.87.87 0 0 1 .425-1.63h6.168z",
      fill: `url(#${o.uniqueID}c)`
    }, null, 8, h),
    t("path", {
      d: "m7.239 16.878-1.757.96A1.001 1.001 0 0 1 4 16.96V7.45a1.9 1.9 0 0 1 .954-1.65l6.192-3.553a1.869 1.869 0 0 1 1.642-.107 1.86 1.86 0 0 1 1.15 1.724v1.8L8.904 7.5a1.415 1.415 0 0 0-.93 1.33v6.807a1.415 1.415 0 0 1-.736 1.24z",
      fill: `url(#${o.uniqueID}d)`
    }, null, 8, m),
    t("path", {
      d: "M13.937 17.963v2.214a1.82 1.82 0 0 1-2.713 1.59l-3.88-2.174a.87.87 0 0 1 .425-1.63h6.168z",
      fill: `url(#${o.uniqueID}e)`
    }, null, 8, y),
    t("defs", null, [
      t("linearGradient", {
        id: `${o.uniqueID}a`,
        x1: "16.235",
        y1: ".94",
        x2: "16.235",
        y2: "20.54",
        gradientUnits: "userSpaceOnUse"
      }, q, 8, I),
      t("linearGradient", {
        id: `${o.uniqueID}b`,
        x1: "12.782",
        y1: "1.762",
        x2: "2.29",
        y2: "16.747",
        gradientUnits: "userSpaceOnUse"
      }, v, 8, D),
      t("linearGradient", {
        id: `${o.uniqueID}c`,
        x1: "7.462",
        y1: "19.982",
        x2: "20.393",
        y2: "19.982",
        gradientUnits: "userSpaceOnUse"
      }, z, 8, B),
      t("linearGradient", {
        id: `${o.uniqueID}d`,
        x1: "12.997",
        y1: "1.455",
        x2: "10.775",
        y2: "4.629",
        gradientUnits: "userSpaceOnUse"
      }, A, 8, O),
      t("linearGradient", {
        id: `${o.uniqueID}e`,
        x1: "16.26",
        y1: "20.268",
        x2: "10.46",
        y2: "19.761",
        gradientUnits: "userSpaceOnUse"
      }, x, 8, E)
    ])
  ], 10, u);
}
const j = /* @__PURE__ */ p(c, [["render", F]]);
export {
  j as default
};
//# sourceMappingURL=office-365.js.map
